import { render, staticRenderFns } from "./contacts-info-edit-tab.vue?vue&type=template&id=c673759a&scoped=true"
import script from "./contacts-info-edit-tab.vue?vue&type=script&lang=js"
export * from "./contacts-info-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./contacts-info-edit-tab.vue?vue&type=style&index=0&id=c673759a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c673759a",
  null
  
)

export default component.exports